import * as React from "react"
import { Button, ButtonProps } from "@chakra-ui/react"
import useOnClickWithTouchHandler from "../../../hooks/useOnClickWithTouchHandler"

export interface IconButtonProps extends ButtonProps {
  isMobile?: boolean
}

export const _IconButton: React.FC<IconButtonProps> = ({
  children,
  isMobile,
  onClick,
  width,
  height,
  bottom,
  top,
  right,
  className,
  ...props
}) => {
  const handleCallback = useOnClickWithTouchHandler(onClick)

  return (
    <Button
      padding="0px"
      paddingInlineEnd="0px"
      paddingInlineStart="0px"
      minW="unset"
      minH="unset"
      top={isMobile ? `calc(${top} + -4px)` : top}
      right={isMobile ? `calc(${right} + -4px)` : right}
      background="transperent"
      height={isMobile ? `calc(${height} + 0.5rem)` : height}
      width={isMobile ? `calc(${width} + 0.5rem)` : width}
      {...handleCallback}
      {...props}
      _hover={{ background: "transperent" }}
      _active={{}}
      _focus={{}}
      className={`${className} icon-ios`}
    >
      {children}
    </Button>
  )
}

export const IconButton = React.memo(_IconButton)
